import $ from 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';

$('body').on('loaded', function() {
  AOS.init({
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: 'ease-in', // default easing for AOS animations
  });
});
